import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiPlus, FiMinus } from 'react-icons/fi';
import SEO from '../components/SEO';

const faqs = [
    {
        q: "¿Puedo usar estos planos directamente para mi Construcción o licencia municipal?",
        a: "No. Nuestros planos son diseños de referencia arquitectónica. Antes de iniciar cualquier construcción, es obligatorio que un Ingeniero Civil o Arquitecto colegiado valide el diseño, realice el cálculo estructural y adapte los planos a las normativas de tu municipalidad y las condiciones específicas de tu terreno."
    },
    {
        q: "¿Qué recibo exactamente al realizar la compra?",
        a: "Recibirás un archivo comprimido que incluye los planos arquitectónicos en formato PDF (listos para imprimir) y/o archivos CAD (AutoCAD), lo que te permite realizar modificaciones técnicas con un profesional. todo dependeindo del pedido que realices."
    },
    {
        q: "¿Quién realiza los diseños de los planos?",
        a: "En Planix seleccionamos y curamos los mejores diseños de arquitectura global y tendencias digitales. Actuamos como un catálogo inteligente que pone a tu alcance ideas de vanguardia. Es importante recordar que cada plano es una base conceptual que debe ser validada y adaptada por un profesional colegiado en tu zona para cumplir con las normativas locales."
    },
    {
        q: "¿Los planos son aptos para construir de inmediato?",
        a: "Nuestros planos son diseños de referencia arquitectónica. Antes de poner la primera piedra, es obligatorio que un Ingeniero Civil o Arquitecto colegiado valide el diseño, realice el cálculo estructural y adapte los planos a las normativas de tu municipalidad."
    },
    {
        q: "¿Por qué es necesario un estudio de suelos?",
        a: "Cada terreno es único (arena, arcilla, roca). El estudio de suelos determina qué tipo de cimentación necesita tu casa para ser segura ante sismos. No recomendamos iniciar ninguna obra sin este análisis previo."
    },
    {
        q: "¿Necesito un Maestro de Obra o un Ingeniero?",
        a: "Lo ideal es contar con ambos. El Ingeniero garantiza la seguridad estructural y legal, mientras que el Maestro de Obra lidera la ejecución técnica. Siempre recomendamos que el Maestro trabaje bajo la supervisión de los planos validados por el profesional."
    },
    {
        q: "¿Puedo solicitar modificaciones a un diseño existente?",
        a: "¡Sí! Si te gusta un modelo pero necesitas un cuarto extra o mover la cocina, podemos personalizarlo. Contáctanos por WhatsApp indicando el ID del plano para darte un presupuesto por la adaptación."
    },
    {
        q: "¿Cuáles son los métodos de pago disponibles?",
        a: "Para tu comodidad aceptamos Yape, Plin, transferencias bancarias (BCP, BBVA, Interbank) y pagos con tarjeta de crédito/débito a través de nuestra pasarela segura."
    },
    {
        q: "¿Qué pasa si pierdo el archivo que compré?",
        a: "No te preocupes. Escríbenos con tu comprobante o correo de compra y te reenviaremos el enlace de descarga sin costo adicional."
    }
];

const FAQ = () => {
    const [active, setActive] = useState(null);

    return (
        <div className="pt-32 pb-20 max-w-3xl mx-auto px-6">
            <SEO
                title="Preguntas Frecuentes sobre Planos y Construcción"
                description="Respuestas sobre planos arquitectónicos, archivos CAD, construcción y servicios técnicos."
                image="https://www.planixapp.com/cover.jpg"
                canonical="https://www.planixapp.com/preguntas-frecuentes"
                keywords="preguntas frecuentes planos, dudas comunes construcción, archivos CAD, validación profesional, estudio de suelos, maestro de obra, métodos de pago Planix"
                structuredData={{
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": faqs.map((faq) => ({
                        "@type": "Question",
                        "name": faq.q,
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": faq.a
                        }
                    }))
                }}
            />

            <h1 className="text-4xl font-black text-[#1C1C1C] mb-8 tracking-tighter">Preguntas <span className="text-[#F26B1D]">Frecuentes</span></h1>
            <div className="space-y-4">
                {faqs.map((faq, i) => (
                    <div key={i} className="border border-gray-100 rounded-2xl overflow-hidden bg-white shadow-sm">
                        <button
                            onClick={() => setActive(active === i ? null : i)}
                            className="w-full p-5 text-left flex justify-between items-center bg-white hover:bg-gray-50 transition-colors"
                        >
                            <span className="font-bold text-[#1C1C1C] text-sm md:text-base">{faq.q}</span>
                            {active === i ? <FiMinus className="text-[#F26B1D]" /> : <FiPlus />}
                        </button>
                        <AnimatePresence>
                            {active === i && (
                                <motion.div
                                    initial={{ height: 0 }} animate={{ height: 'auto' }} exit={{ height: 0 }}
                                    className="overflow-hidden"
                                >
                                    <p className="p-5 text-gray-500 text-sm border-t border-gray-50 leading-relaxed">{faq.a}</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                ))}
            </div>

            <div className="mt-12 p-8 bg-[#F26B1D]/5 rounded-[2rem] border border-[#F26B1D]/20 text-center">
                <p className="text-gray-600 font-medium mb-4">¿Tienes una duda específica sobre un terreno?</p>
                <a
                    href="https://wa.me/51983974833"
                    target="blank_blank"
                    className="inline-flex items-center gap-2 bg-[#1C1C1C] text-white px-8 py-3 rounded-xl font-bold hover:bg-[#F26B1D] transition-all uppercase text-xs tracking-widest"
                >
                    Consultar por WhatsApp
                </a>
            </div>
        </div>
    );
};

export default FAQ;